import * as $runtime from "../runtime.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const $Event = (tag, _1) => ({tag, _1});
const $ItemList = tag => ({tag});
const Menu = /* #__PURE__ */ $ItemList("Menu");
const CreatorCrossSelling = /* #__PURE__ */ $ItemList("CreatorCrossSelling");
const CartCrossSelling = /* #__PURE__ */ $ItemList("CartCrossSelling");
const AddToCart = value0 => $Event("AddToCart", value0);
const LocateMe = /* #__PURE__ */ $Event("LocateMe");
const RemoveFromCart = value0 => $Event("RemoveFromCart", value0);
const BeginCheckout = value0 => $Event("BeginCheckout", value0);
const Purchase = value0 => $Event("Purchase", value0);
const SetCheckoutOption = value0 => $Event("SetCheckoutOption", value0);
const genericItemList_ = {
  to: x => {
    if (x.tag === "Inl") { return Menu; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return CreatorCrossSelling; }
      if (x._1.tag === "Inr") { return CartCrossSelling; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Menu") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "CreatorCrossSelling") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "CartCrossSelling") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments)); }
    $runtime.fail();
  }
};
const showItemList = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Menu"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "CreatorCrossSelling"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "CartCrossSelling"});
    return x => {
      const $3 = genericItemList_.from(x);
      if ($3.tag === "Inl") { return $0["genericShow'"]($3._1); }
      if ($3.tag === "Inr") {
        if ($3._1.tag === "Inl") { return $1["genericShow'"]($3._1._1); }
        if ($3._1.tag === "Inr") { return $2["genericShow'"]($3._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const encodeItemList = {
  encode: x => {
    const $0 = genericItemList_.from(x);
    if ($0.tag === "Inl") { return "Menu"; }
    if ($0.tag === "Inr") {
      if ($0._1.tag === "Inl") { return "CreatorCrossSelling"; }
      if ($0._1.tag === "Inr") { return "CartCrossSelling"; }
      $runtime.fail();
    }
    $runtime.fail();
  }
};
const promotionalCategory = "Promotional";
const nonPromotionalCategory = "NonPromotional";
const genericEvent = {
  to: x => {
    if (x.tag === "Inl") { return $Event("AddToCart", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return LocateMe; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return $Event("RemoveFromCart", x._1._1._1); }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return $Event("BeginCheckout", x._1._1._1._1); }
          if (x._1._1._1.tag === "Inr") {
            if (x._1._1._1._1.tag === "Inl") { return $Event("Purchase", x._1._1._1._1._1); }
            if (x._1._1._1._1.tag === "Inr") { return $Event("SetCheckoutOption", x._1._1._1._1._1); }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "AddToCart") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "LocateMe") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "RemoveFromCart") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))); }
    if (x.tag === "BeginCheckout") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))); }
    if (x.tag === "Purchase") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))));
    }
    if (x.tag === "SetCheckoutOption") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1)))));
    }
    $runtime.fail();
  }
};
const encodingOpts = /* #__PURE__ */ (() => (
  {
    sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
    unwrapSingleConstructors: true,
    unwrapSingleArguments: true,
    unwrapSingleRecordArguments: true,
    fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
  }
))();
const encodeForeignEvent = {
  encode: /* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "AddToCart"})((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "quantity"
      })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "price"})({encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode}))({
        reflectSymbol: () => "name"
      })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "list"})({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return encodeItemList.encode(v2._1); }
          $runtime.fail();
        }
      }))({reflectSymbol: () => "category"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "LocateMe"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "RemoveFromCart"})((() => {
      const $2 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "quantity"
      })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "price"})({encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode}))({
        reflectSymbol: () => "name"
      })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "list"})({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return encodeItemList.encode(v2._1); }
          $runtime.fail();
        }
      }))({reflectSymbol: () => "category"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $2.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "BeginCheckout"})((() => {
      const $3 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "items"})((() => {
        const $3 = Data$dFunctor.arrayMap(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
          reflectSymbol: () => "quantity"
        })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "price"})({encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode}))({
          reflectSymbol: () => "name"
        })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "list"})({
          encodeWithOptions: v => v2 => {
            if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
            if (v2.tag === "Just") { return encodeItemList.encode(v2._1); }
            $runtime.fail();
          }
        }))({reflectSymbol: () => "category"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions));
        return {encodeWithOptions: v => $3};
      })());
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $3.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $4 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Purchase"})((() => {
      const $4 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "transactionId"
      })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "total"})({encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode}))({
        reflectSymbol: () => "shipping"
      })({encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode}))({reflectSymbol: () => "items"})((() => {
        const $4 = Data$dFunctor.arrayMap(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
          reflectSymbol: () => "quantity"
        })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "price"})({encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode}))({
          reflectSymbol: () => "name"
        })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "list"})({
          encodeWithOptions: v => v2 => {
            if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
            if (v2.tag === "Just") { return encodeItemList.encode(v2._1); }
            $runtime.fail();
          }
        }))({reflectSymbol: () => "category"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions));
        return {encodeWithOptions: v => $4};
      })()))({reflectSymbol: () => "coupon"})({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return v2._1; }
          $runtime.fail();
        }
      }))({reflectSymbol: () => "affiliation"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $4.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $5 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "SetCheckoutOption"})((() => {
      const $5 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "selectedValue"
      })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "selectedOption"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $5.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    return x => {
      const $6 = genericEvent.from(x);
      if ($6.tag === "Inl") {
        return $0.encodeOpts({
          sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
          unwrapSingleConstructors: false,
          unwrapSingleArguments: true,
          unwrapSingleRecordArguments: true,
          fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
        })($6._1);
      }
      if ($6.tag === "Inr") {
        if ($6._1.tag === "Inl") {
          return $1.encodeOpts({
            sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: true,
            unwrapSingleRecordArguments: true,
            fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
          })($6._1._1);
        }
        if ($6._1.tag === "Inr") {
          if ($6._1._1.tag === "Inl") {
            return $2.encodeOpts({
              sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
              unwrapSingleConstructors: false,
              unwrapSingleArguments: true,
              unwrapSingleRecordArguments: true,
              fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
            })($6._1._1._1);
          }
          if ($6._1._1.tag === "Inr") {
            if ($6._1._1._1.tag === "Inl") {
              return $3.encodeOpts({
                sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
                unwrapSingleConstructors: false,
                unwrapSingleArguments: true,
                unwrapSingleRecordArguments: true,
                fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
              })($6._1._1._1._1);
            }
            if ($6._1._1._1.tag === "Inr") {
              if ($6._1._1._1._1.tag === "Inl") {
                return $4.encodeOpts({
                  sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
                  unwrapSingleConstructors: false,
                  unwrapSingleArguments: true,
                  unwrapSingleRecordArguments: true,
                  fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
                })($6._1._1._1._1._1);
              }
              if ($6._1._1._1._1.tag === "Inr") {
                return $5.encodeOpts({
                  sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
                  unwrapSingleConstructors: false,
                  unwrapSingleArguments: true,
                  unwrapSingleRecordArguments: true,
                  fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
                })($6._1._1._1._1._1);
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const toPlatformEvent = v => {
  if (v.tag === "AddToCart") { return {name: "AddToCart", value: encodeForeignEvent.encode(v)}; }
  if (v.tag === "LocateMe") { return {name: "LocateMe", value: encodeForeignEvent.encode(v)}; }
  if (v.tag === "RemoveFromCart") { return {name: "RemoveFromCart", value: encodeForeignEvent.encode(v)}; }
  if (v.tag === "BeginCheckout") { return {name: "BeginCheckout", value: encodeForeignEvent.encode(v)}; }
  if (v.tag === "Purchase") { return {name: "Purchase", value: encodeForeignEvent.encode(v)}; }
  if (v.tag === "SetCheckoutOption") { return {name: "SetCheckoutOption", value: encodeForeignEvent.encode(v)}; }
  $runtime.fail();
};
const dailyLunchesCategory = "daily_lunches";
export {
  $Event,
  $ItemList,
  AddToCart,
  BeginCheckout,
  CartCrossSelling,
  CreatorCrossSelling,
  LocateMe,
  Menu,
  Purchase,
  RemoveFromCart,
  SetCheckoutOption,
  dailyLunchesCategory,
  encodeForeignEvent,
  encodeItemList,
  encodingOpts,
  genericEvent,
  genericItemList_,
  nonPromotionalCategory,
  promotionalCategory,
  showItemList,
  toPlatformEvent
};
